import { BusyoComboBox } from "./BusyoComboBox"
import { BusyoGroupComboBox } from "./BusyoGroupComboBox"
import { DefaultComboBox } from "./DefaultComboBox"
import { EigyosyokanComboBox } from "./EigyosyokanComboBox"
import { EigyosyoComboBox } from "./EigyosyoComboBox"
import { HyosiBunkatuComboBox } from "./HyosiBunkatuComboBox"
import { KaisyaComboBox } from "./KaisyaComboBox"
import { KubunComboBox } from "./KubunComboBox"
import { SeikyuUtiwakeComboBox } from "./SeikyuUtiwakeComboBox"
import { SiharaiSakiComboBox } from "./SiharaiSakiComboBox"
import { SyainComboBox } from "./SyainComboBox"
import { GinkoKozaComboBox } from "./GinkoKozaComboBox"
import { TodohukenComboBox } from "./TodohukenComboBox"
import { SikutyosonComboBox } from "./SikutyosonComboBox"
import { ZyomuinComboBox } from "./ZyomuinComboBox"
import { VacationNendoComboBox } from "./VacationNendoComboBox"
import { VacationTukiComboBox } from "./VacationTukiComboBox"
import { BusyoKengenComboBox } from "./BusyoKengenComboBox"
import { AQTableComboBox } from "./AQTableComboBox"

const ComboBox = {
  SeikyuUtiwake: SeikyuUtiwakeComboBox,
  Kaisya: KaisyaComboBox,
  Eigyosyokan: EigyosyokanComboBox,
  Eigyosyo: EigyosyoComboBox,
  Busyo: BusyoComboBox,
  BusyoKengen: BusyoKengenComboBox,
  BusyoGroup: BusyoGroupComboBox,
  Kubun: KubunComboBox,
  HyosiBunkatu: HyosiBunkatuComboBox,
  Syain: SyainComboBox,
  GinkoKoza: GinkoKozaComboBox,
  Default: DefaultComboBox,
  SiharaiSaki: SiharaiSakiComboBox,
  Todohuken: TodohukenComboBox,
  Sikutyoson: SikutyosonComboBox,
  Zyomuin: ZyomuinComboBox,
  VacationNendo: VacationNendoComboBox,
  VacationTuki: VacationTukiComboBox,
  AQTable: AQTableComboBox,
}

export default ComboBox
